import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="HRM">
                <h1>Custom POS Development Company</h1>
              </div>
              <div className=" banner_content_txt listing_flex">
                <p>
                  We are a POS development company specializing in creating
                  tailored product solutions to help retail businesses catch the
                  competitive advantage.
                </p>
                <ul>
                  <li>Seamless, integrated invoicing</li>
                  <li>Secure payment solutions</li>
                  <li>Self-operating loyalty records</li>
                  <li>Efficient inventory management</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
